import { defineComponent as _defineComponent } from 'vue'
import { useViewport } from '@travelata-libs/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCertificatesBanner',
  props: {
  link: {
    type: String,
    default:
        'https://gift.travelata.ru/?utm_source=travelata&utm_medium=banner&utm_campaign=gift_certificates&utm_content=main',
  },
  openInNewTab: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: 'Чтобы подарок ',
  },
  titleWrapping: {
    type: String,
    default: 'не пылился на полке',
  },
  subtitle: {
    type: String,
    default: 'Сертификат на отдых — лучший сюрприз для близких',
  },
  buttonText: {
    type: String,
    default: 'Выбрать сертификат',
  },
  customClass: {
    type: String,
    default: '',
  },
  customClassContainer: {
    type: String,
    default: '',
  },
} as const,
  setup(__props) {

const props = __props



const { isMobile } = useViewport();

function openLinkCertificates() {
  if (props.openInNewTab) {
    window.open(props.link, '_blank', 'noopener');
  } else {
    window.location.href = props.link;
  }
}

return { __sfc: true,props, isMobile, openLinkCertificates }
}

})